<div style="position: relative;">
    <div class="table-toolbar">
      
      <div *ngIf="isReadonly && allProductsUpToDate">
        <button mat-icon-button color="accent" (click)="delete()">
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button color="accent" (click)="startEdit()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    
      <div *ngIf="isReadonly && !allProductsUpToDate">
        <mat-slide-toggle [checked]="displayProductUpdates"
                          (change)="displayProductUpdates = $event.source.checked">
          <div class="slideToggleLabel">
            ÄNDERUNGEN ANZEIGEN
          </div>
        </mat-slide-toggle>

        <div *ngIf="containsOutdatedProduct" class="display-inline-block">
          <button mat-button
                  class="applyProductUpdatesButton" 
                  color="accent"
                  [disabled]="!displayProductUpdates"
                  (click)="alignEntriesToCurrentProducts()">
            <mat-icon>done</mat-icon>
            ÄNDERUNGEN ÜBERNEHMEN
          </button>
          <mat-icon class="info-icon" 
                    color="primary"
                    matTooltipPosition="above"
                    matTooltip="Die Artikelstammdaten haben sich geändert. Die Änderungen können durch einen Klick auf &quot;ÄNDERUNGEN ANZEIGEN&quot; 
                      sichtbar gemacht und anschließend mit &quot;ÄNDERUNGEN ÜBERNEHMEN&quot; übernommen werden.
                      Diese Tabelle kann erst wieder bearbeitet werden nachdem die Änderungen der Artikelstammdaten übernommen wurden.">
            info_outline
          </mat-icon>
        </div>
        
        <div *ngIf="containsDeletedProduct" class="display-inline-block">
          <button mat-button 
                  color="accent" 
                  class="applyProductUpdatesButton"
                  [disabled]="!displayProductUpdates"
                  (click)="alignEntriesToCurrentProducts()">
            <mat-icon>done</mat-icon>
            ÄNDERUNGEN ÜBERNEHMEN
          </button>
          <mat-icon class="info-icon"
                    color="primary"
                    matTooltipPosition="above"
                    matTooltip="Die Artikelstammdaten haben sich geändert. Diese Tabelle enthält unter anderem Artikel, die gelöscht wurden.
                      Die Änderungen können durch einen Klick auf &quot;ÄNDERUNGEN ANZEIGEN&quot; 
                      sichtbar gemacht und anschließend mit &quot;ÄNDERUNGEN ÜBERNEHMEN&quot; übernommen werden.
                      Diese Tabelle kann erst wieder bearbeitet werden nachdem die Änderungen der Artikelstammdaten übernommen wurden.">
            info_outline
          </mat-icon>
        </div>

        <div *ngIf="containsOnlyDeletedProducts"  class="display-inline-block">
          <button mat-button 
                  color="accent" 
                  class="applyProductUpdatesButton"
                  (click)="delete()"
                  [disabled]="!displayProductUpdates">
            <mat-icon>done</mat-icon>
            ÄNDERUNGEN ÜBERNEHMEN
          </button>
          <mat-icon class="info-icon" 
                    color="primary"
                    matTooltipPosition="above"
                    matTooltip="Die Artikelstammdaten haben sich geändert. Diese Tabell enthält aussließlich Artikel, die gelöscht wurden.
                    Die Änderungen können durch einen Klick auf &quot;ÄNDERUNGEN ANZEIGEN&quot; 
                    sichtbar gemacht und anschließend mit &quot;ÄNDERUNGEN ÜBERNEHMEN&quot; übernommen werden.
                    Diese Tabelle kann erst wieder bearbeitet werden nachdem die Änderungen der Artikelstammdaten übernommen wurden.">
            info_outline
          </mat-icon>
        </div>
        
      </div>
      
      <div *ngIf="!isReadonly">
        <button mat-icon-button *ngIf="!isReadonly" color="accent" (click)="discardChanges()">
          <mat-icon>clear</mat-icon>
        </button>
        <button mat-icon-button *ngIf="!isReadonly" [disabled]="numberOfEntries < 1 || sectionTableForm.invalid" color="accent" (click)="saveChanges()">
          <mat-icon>done</mat-icon>
        </button>
        <mat-icon *ngIf="sectionTableForm.invalid" 
                  class="info-icon" 
                  color="primary"
                  matTooltipPosition="above"
                  matTooltip="Alle Werte in der Spalte &quot;Rabatt&quot; müssen zwischen 0 und 100 liegen.">
          info_outline
        </mat-icon>
      </div>

    </div>

    <form #sectionTableForm="ngForm">
      <mat-table class="section-table"
                 [dataSource]="entries$"
                 cdkDropList
                 (cdkDropListDropped)="onDrop($event)">
        <!-- Internal Id Column -->
        <ng-container matColumnDef="productId">
          <mat-header-cell *matHeaderCellDef> Art. Nr. </mat-header-cell>
          <mat-cell
              *matCellDef="let entry;"
              [class.productDeleted] = "displayProductUpdates && entry.relatedProductWasDeleted"
              [class.move-cursor]="!isReadonly && numberOfEntries > 1"
              (mousedown)="dragDisabled = isReadonly || numberOfEntries === 1"> 
              <mat-icon *ngIf="!isReadonly && numberOfEntries > 1" class="row-reorder-icon">height</mat-icon>
              {{entry.product?.id}}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>
            
        <!-- Quantity Column -->
        <ng-container matColumnDef="quantity">
          <mat-header-cell *matHeaderCellDef> Menge </mat-header-cell>
          <mat-cell class="right-aligned-cell" *matCellDef="let entry; let rowIdx = index;"> 
            <div class="editable-cell numeric-cell-input" *ngIf="!isReadonly; else readonlyQuantity">
              <input matInput 
                    #name="ngModel"
                    name="quantity{{rowIdx}}"      
                    type="number" 
                    [(ngModel)]="entry.quantity">
            </div>
            <ng-template #readonlyQuantity>
              <div class="align-to-numeric-cell-input" 
                   [class.productDeleted] = "displayProductUpdates && (containsOnlyDeletedProducts || entry.relatedProductWasDeleted)">
                {{entry.quantity}}
              </div>
            </ng-template> 
          </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>

        <!-- Discount Column -->
        <ng-container matColumnDef="discountFactor">
          <mat-header-cell *matHeaderCellDef> Rabatt [%] </mat-header-cell>
          <mat-cell class="right-aligned-cell" *matCellDef="let entry; let rowIdx = index;">
            <div *ngIf="isReadonly"
                 class="align-to-numeric-cell-input"
                 [class.productDeleted] = "displayProductUpdates && (containsOnlyDeletedProducts || entry.relatedProductWasDeleted)">
              {{entry.discountFactor * 100}}
            </div> 
            <div *ngIf="!isReadonly"> 
              <input matInput 
                    #discountFactor="ngModel"
                    name="discountFactor{{rowIdx}}"
                    [ngClass]="discountFactor.invalid ? 'numeric-cell-input editable-cell invalid-value' : 'numeric-cell-input editable-cell'"
                    type="number" 
                    min="0" 
                    max="100" 
                    step="10"
                    pattern="(^100$)|(^[0-9]{1,2}$)"
                    required
                    [ngModel]="entry.discountFactor * 100 "
                    (ngModelChange)="entry.discountFactor=$event / 100">
            </div>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>

        <!-- Description Column --> 
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef> Beschreibung </mat-header-cell>
          <mat-cell *matCellDef="let entry; let rowIdx = index;"> 
            <div class="width-100-percent">
              
              <!-- Product Related Entry -->
              <div *ngIf="entry.entryType === entryTypes.ProductRelatedEntry"
                   [class.productDeleted] = "displayProductUpdates && entry.relatedProductWasDeleted">
                <div *ngIf="isReadonly; else editablePrductRelatedEntry">
                  <div *ngIf="displayProductUpdates && entry.relatedProductWasUpdated">
                    {{entry.latestProduct.name}}
                  </div>
                  <div [class.productOutdated] = "displayProductUpdates && entry.relatedProductWasUpdated">
                    {{entry.product.name}}
                  </div>
                </div>
                <ng-template #editablePrductRelatedEntry>
                  <mat-select #productSelect class="product-select" [value]="entry.product.id" (selectionChange)="onProductSelected(entry, $event.value)">
                    <mat-option *ngFor="let product of products"
                                [value]="product.id">
                      <mat-icon *ngIf="productSelect.panelOpen"
                                [ngStyle]="{'visibility': isAlreadyPartOfSelection(product.id) ? 'visible' : 'hidden' }">
                        done
                      </mat-icon>
                      {{product.name}}
                    </mat-option>
                  </mat-select>
                </ng-template> 
              </div>

              <!-- Custom Entry -->
              <div *ngIf="entry.entryType === entryTypes.CustomEntry">
                <div *ngIf="isReadonly; else editableCustomEntry"
                    [class.productDeleted] = "displayProductUpdates && containsOnlyDeletedProducts"> 
                  {{entry.description}} 
                </div>
                <ng-template #editableCustomEntry> 
                  <input matInput
                         class="editable-cell"
                         [maxlength]="MAX_CUSTOM_ENTRY_DESCRIPTION_LENGTH"
                         [ngModel]="entry.description"
                         (ngModelChange)="entry.description=$event"
                         name="customEntryDescription{{rowIdx}}" type="text" />
                </ng-template> 
              </div>

            </div>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>
            <div class="width-100-percent">
              <button mat-button
                    *ngIf="!isReadonly"
                    type="button"
                    [disabled]="products?.length <= 0"
                    class="add-prduct-button"
                    color="accent" (click)="addPrductRelatedEntry()">
                <mat-icon>add</mat-icon>
                POSITION HINZUFÜGEN
              </button>
              <button mat-button *ngIf="!isReadonly" type="button" class="add-custom-position-button" color="accent" (click)="addCustomEntry()">
                <mat-icon>add</mat-icon>
                BENUTZERDEFINIERTE POSITION HINZUFÜGEN
              </button>
            </div> 
          </mat-footer-cell>
        </ng-container>
            
        <!-- Price Per Unit Column -->
        <ng-container matColumnDef="pricePerUnit">
          <mat-header-cell [ngClass]="'right-aligned-cell'" *matHeaderCellDef> Einzelpreis </mat-header-cell>
          <mat-cell class="right-aligned-cell" *matCellDef="let entry; let rowIdx = index;"> 
            <div *ngIf="isReadonly || entry.entryType !== entryTypes.CustomEntry">
              <div *ngIf="displayProductUpdates && entry.relatedProductWasUpdated">
                {{entry.getPricePerUnit(true) | currency}}
              </div>
              <div [class.productOutdated] = "displayProductUpdates && entry.relatedProductWasUpdated"
                   [class.productDeleted] = "displayProductUpdates && (containsOnlyDeletedProducts || entry.relatedProductWasDeleted)">
                {{entry.pricePerUnit | currency}} 
              </div>
            </div> 
            <div *ngIf="!isReadonly && entry.entryType === entryTypes.CustomEntry"
                 class="display-inline-flex"> 
              <input matInput 
                     #name="ngModel"
                     name="pricePerUnit{{rowIdx}}"
                     class="numeric-cell-input price-per-unit-input editable-cell" 
                     type="number"
                     [(ngModel)]="entry.pricePerUnit"/>
              <label class="currency-label">€</label>
            </div>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>
        
        <!-- AP Column -->
        <ng-container matColumnDef="ap">
          <mat-header-cell *matHeaderCellDef> AP </mat-header-cell>
          <mat-cell *matCellDef="let entry; let rowIdx = index;"> 
            <mat-checkbox 
              name="isAlternative{{rowIdx}}"
              [disabled]="isReadonly" 
              [(ngModel)]="entry.isAlternative"></mat-checkbox>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>

        <!-- Total Cost Column -->
        <ng-container matColumnDef="totalCost">
          <mat-header-cell [ngClass]="'right-aligned-cell'" *matHeaderCellDef> Gesamtkosten </mat-header-cell>
          <mat-cell class="right-aligned-cell" *matCellDef="let entry" [class.alternative-position-price] = "entry.isAlternative">
            <div *ngIf="entry.entryType !== entryTypes.CustomEntry; else cutomEntryTotalCost">
              <div *ngIf="displayProductUpdates && entry.relatedProductWasUpdated">
                {{entry.getTotalCosts(true, entry.quantity) | currency}}
              </div>
              <div [class.productOutdated] = "displayProductUpdates && entry.relatedProductWasUpdated"
                   [class.productDeleted] = "displayProductUpdates && entry.relatedProductWasDeleted">
                {{entry.getTotalCosts(false, entry.quantity) | currency}}
              </div>
            </div>
            <ng-template #cutomEntryTotalCost>
              <div [class.productDeleted] = "displayProductUpdates && containsOnlyDeletedProducts">
                {{getEntryTotalCosts(entry, entry.quantity) | currency}}
              </div>
            </ng-template>
          </mat-cell>
          <mat-footer-cell class="right-aligned-cell" *matFooterCellDef> {{totalCosts | currency}} </mat-footer-cell>
        </ng-container>
            
        <!-- Delete Row Column -->
        <ng-container matColumnDef="delete">
          <mat-header-cell *matHeaderCellDef [ngClass]="'delete-column'"> </mat-header-cell>
          <mat-cell *matCellDef="let entry" [ngClass]="'delete-column'"> 
            <button mat-icon-button *ngIf="!isReadonly && numberOfEntries > 1" type="button" color="accent" (click)="removeEntry(entry)">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>
              
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"
                 cdkDrag 
                 cdkDragLockAxis="y"
                 [cdkDragDisabled]="dragDisabled">
          <div *cdkDragPlaceholder></div>
        </mat-row>
        <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
      </mat-table>
    </form>
</div>
  
  
